import React, { useCallback, useMemo } from "react";
import Accordion from "../accordion";

import "./apply-advanced-filters.scss";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ApplyAdvancedFilters = ({ appliedFilters, filtersModel, onClearFilter, onClearAllFilters }) => {
    const displayedFilters = appliedFilters.filter(({ value }) => !!value);
    const formFields = useMemo(() => {
        return Object.keys(filtersModel).map((key) => {
            return filtersModel[key];
        });
    }, []);

    const transformLabel = useCallback((id) => {
        const field = formFields.find(({ name }) => name === id);

        if (!field) {
            return id;
        }

        return field.label;
    }, []);

    return (
        <Accordion startingIndex={0} enableSeparator={false} stretchBody titleClasses="accordion-tab">
            <div label="Applied Filters">
                <div className="header">
                    <span className="filter-count">{displayedFilters.length} Applied Filters</span>
                    <button type="button" className="button -text" onClick={onClearAllFilters}>
                        Clear All
                    </button>
                </div>
                <div className="filters">
                    {displayedFilters.map(({ id, displayValue }) => {
                        return (
                            <div key={id} className="filter">
                                <FontAwesomeIcon onClick={() => onClearFilter(id)} className="filter-close cursor-pointer" icon={faClose} />
                                <div className="filter-header">{transformLabel(id)}</div>
                                <div className="filter-value">
                                    Contains: <span>{displayValue}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Accordion>
    );
};

// export const Tab
